import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//

export default {
  props: {
    endTime: {
      type: Number,
      required: true
    },
    currentTime: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      interval: null,
      countTime: 0,
      // 倒计时剩余总时间
      countTimeStr: ''
    };
  },
  mounted: function mounted() {
    this.countTime = this.endTime - this.currentTime;
    if (this.endTime > this.currentTime && this.countTime < 24 * 60 * 60 * 1000) {
      this.startCountTime();
    }
  },
  methods: {
    initCountDownStr: function initCountDownStr(duration) {
      var hour;
      var minute;
      var second;
      hour = Math.floor(duration / (60 * 60 * 1000));
      minute = Math.floor((duration - hour * 60 * 60 * 1000) / (60 * 1000));
      second = Math.floor((duration - hour * 60 * 60 * 1000 - minute * 60 * 1000) / 1000);
      this.countTimeStr = "".concat(hour < 10 ? '0' + hour : hour, ":").concat(minute < 10 ? '0' + minute : minute, ":").concat(second < 10 ? '0' + second : second);
    },
    startCountTime: function startCountTime() {
      var _this = this;
      clearInterval(this.interval);
      this.interval = setInterval(function () {
        _this.countTime = _this.countTime - 1000;
        _this.initCountDownStr(_this.countTime);
        if (_this.countTime <= 0) {
          clearInterval(_this.interval);
          _this.$emit('onCountDownFinish');
        }
      }, 1000);
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
  }
};